import React, { useState } from "react";
import Button from "../inputs/Button";
import Input from "../inputs/Input";
import AlertBanner from "../shared/AlertBanner";
import Modal from "../shared/Modal";
import Textarea from "../shared/Textarea";

const FinalReportModal = ({ isOpen, onClose, onSubmit }) => {
  const [reportName, setReportName] = useState("");
  const [reportSummary, setReportSummary] = useState("");

  const handleSubmit = () => {
    onSubmit({ reportName, reportSummary });
    setReportName("");
    setReportSummary("");
  };

  const handleClose = () => {
    setReportName("");
    setReportSummary("");
    onClose();
  };

  const footer = (
    <div className="flex justify-end space-x-3">
      <Button variant="outline" onClick={handleClose}>
        Cancel
      </Button>
      <Button
        variant="primary"
        className="bg-emerald-800 hover:bg-emerald-900"
        onClick={handleSubmit}
      >
        Submit Final Report
      </Button>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Share Final Report"
      size="md"
      footer={footer}
    >
      <div className="space-y-4">
        <Input
          label="Report Title"
          name="reportName"
          placeholder="e.g., Final Decision Report - Miami-Dade Flood Map Review"
          required
          field={{
            value: reportName,
            onChange: (value) => setReportName(value),
          }}
        />

        <Textarea
          label="Executive Summary"
          name="reportSummary"
          placeholder="Provide a brief summary of the panel's findings and decision..."
          rows={4}
          required
          value={reportSummary}
          onChange={(e) => setReportSummary(e.target.value)}
        />

        <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
          <svg
            className="w-12 h-12 text-gray-400 mx-auto mb-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <p className="text-sm text-gray-600">Upload Final Report Document</p>
          <p className="text-xs text-gray-500 mt-1">
            PDF format recommended (max 25MB)
          </p>
          <Button variant="outline" size="sm" className="mt-3">
            Select File
          </Button>
        </div>

        <AlertBanner
          type="info"
          title="Important:"
          message="Once submitted, the report will be sent to the Platform Admin for review and publication approval."
        />
      </div>
    </Modal>
  );
};

export default FinalReportModal;
